import { render, staticRenderFns } from "./material-details.vue?vue&type=template&id=97a03ac8&scoped=true&"
import script from "./material-details.vue?vue&type=script&lang=js&"
export * from "./material-details.vue?vue&type=script&lang=js&"
import style0 from "./material-details.vue?vue&type=style&index=0&id=97a03ac8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a03ac8",
  null
  
)

export default component.exports